import { render, staticRenderFns } from "./pantalla7web.vue?vue&type=template&id=59cdd8af&scoped=true&"
import script from "./pantalla7web.vue?vue&type=script&lang=js&"
export * from "./pantalla7web.vue?vue&type=script&lang=js&"
import style0 from "./pantalla7web.vue?vue&type=style&index=0&id=59cdd8af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cdd8af",
  null
  
)

export default component.exports